module.exports = __webpack_public_path__ + "fonts/TelefonicaIconsTracking.866ae375.eot";